import React, { useState } from 'react';
import { WarningDialog, Text } from '@innovyze/stylovyze';
import { Checkbox, FormControlLabel, FormGroup, Grid } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';

interface DisableDataConnectorModalProps {
	open: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

const DisableDataConnectorDialog = (props: DisableDataConnectorModalProps) => {
	const { t } = useGlobalization();

	const { open, onConfirm, onCancel } = props;
	const [checkboxChecked, setCheckboxChecked] = useState(false);

	const handleOnConfirm = () => {
		onConfirm();
		setCheckboxChecked(false);
	};

	return (
		<WarningDialog
			title={t('Disable Data Connector')}
			open={open}
			confirmText={t('Disable')}
			cancelText={t('Cancel')}
			onConfirm={handleOnConfirm}
			onCancel={onCancel}
			confirmButtonProps={{ disabled: !checkboxChecked }}
			dividers="both">
			<Grid container spacing={4}>
				<Grid
					spacing={2}
					item
					xs={12}
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
						alignItems: 'stretch',
						width: '584px',
						minHeight: '192px',
					}}>
					<Text variant="body1">
						{t(
							'Do you really want to disable this data connector?',
						)}
					</Text>

					<br />
					<FormGroup row>
						<FormControlLabel
							control={
								<Checkbox
									checked={checkboxChecked}
									onChange={(
										event: React.ChangeEvent<HTMLInputElement>,
										checked: boolean,
									) => setCheckboxChecked(checked)}
									name="checkedB"
									color="primary"
								/>
							}
							label={t(
								// eslint-disable-next-line max-len
								'I understand that disabling this data connector will cause certain tools, charts, and alerts not to function correctly.',
							)}
						/>
					</FormGroup>
				</Grid>
			</Grid>
		</WarningDialog>
	);
};

export default DisableDataConnectorDialog;
